import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appNumberDecimal]',
  standalone: true
})
export class NumberDecimalDirective {

  @Input() patternType: string = 'default';
  @Input() allowNegative: boolean = false;

    //private regex: RegExp = /^(0|[1-9]\d*)(\.\d{0,2})?$/;
    private regexMap: { [key: string]: RegExp } = {
      default: /^(0|[1-9]\d*)(\.\d{0,2})?$/, // Original regex allowing 2 decimal places
      unlimited: /^(0|[1-9]\d*)(\.\d*)?$/, // Allows unlimited decimals
      integersOnly: /^\d+$/ // Allows only integers (no decimals)
    };

  private negativeRegexMap: { [key: string]: RegExp } = {
    default: /^-?$|^-?\.$|^-?(0|[1-9]\d*)(\.\d{0,2})?$/, // Original regex allowing 2 decimal places (accept negative)
    unlimited: /^-?$|^-?\.$|^-?(0|[1-9]\d*)(\.\d*)?$/, // Allows unlimited decimals (accept negative)
    integersOnly: /^-?$|^-?\d+$/ // Allows only integers (no decimals) (accept negative)
  };

    private specialKeys: string[] = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete'];

    private allowedKeyRegex = /[\d.-]/;
  
    @HostListener('keydown', ['$event'])
  
    onKeyDown(event: KeyboardEvent) {
  
      if (this.specialKeys.includes(event.key)) return;

      const key = event.key;

      if(!this.allowedKeyRegex.test(key)) {
        event.preventDefault();
        return;
      }
  
      const input = event.target as HTMLInputElement;
  
      const currentValue = input.value;

      const start = input.selectionStart ?? 0;
      const end = input.selectionEnd ?? 0;

      let nextValue = currentValue.slice(0, start) + key + currentValue.slice(end);

      if(nextValue.includes(',')) {
        nextValue = nextValue.replaceAll(",", "");
      }

      let selectedRegex;
      
      if(this.allowNegative) {
        selectedRegex = this.negativeRegexMap[this.patternType] || this.negativeRegexMap['default'];
      }else {
        selectedRegex = this.regexMap[this.patternType] || this.regexMap['default'];
      }

      if (!selectedRegex.test(nextValue)) {
        event.preventDefault();
      }
  
    }
  
    @HostListener('paste', ['$event'])
  
    onPaste(event: ClipboardEvent) {
  
      const pasted = event.clipboardData?.getData('text/plain') || '';
  
      const input = event.target as HTMLInputElement;
  
      const nextValue = input.value + pasted;
  
      const selectedRegex = this.regexMap[this.patternType] || this.regexMap['default'];

      if (!selectedRegex.test(nextValue)) {
        event.preventDefault();
      }

    }

}
